/* eslint-disable react/display-name */
// react
import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'

// components
import { Icon, Modal } from '@st-operations/uikit/src/v2'
import ListView from '_components/list-view/index.jsx'
import Header from '_components/header/index.jsx'

import { useQuery } from '_hooks'

import { getLogsEnum, deleteLog } from '_services/changelogs'

import DiffModal from './DiffModal'

import './styles.scss'

const Changelogs = () => {
  const query = useQuery(['collection', 'name', 'id'])
  const hasQuery = query.collection && query.id
  const [createdByOptions, setCreatedByOptions] = useState([])
  const [orgOptions, setOrgOptions] = useState([])
  const [collectionOptions, setCollectionOptions] = useState([])
  const [details, setDetails] = useState(hasQuery ? query : null)

  useEffect(() => {
    getLogsEnum('created_by.email').then(setCreatedByOptions)
    getLogsEnum('created_by.org').then(setOrgOptions)
    getLogsEnum('collection').then(setCollectionOptions)
  }, [])

  return (
    <div id="changelogs-page" className="changelogs">
      <Header title="Changelogs"></Header>
      <div>
        <ListView
          columns={[
            // {
            //   //  NOTE: for local development only
            //   name: 'Delete',
            //   render: ({ _id }) => <button onClick={() => deleteLog(_id)}>delete</button>,
            // },
            {
              name: 'Name',
              key: 'name',
              render: ({ collection, id, _id, name }) => (
                <button
                  onClick={() => setDetails({ collection, id, _id, name })}
                  className="changelogs__view-changes"
                  title="View Changes"
                >
                  <Icon icon="news" type="outline" width="24px" height="24px" color="#13682B" />
                  <span>{name}</span>
                </button>
              ),
              styles: {
                width: 'unset',
                minWidth: '300px',
                textAlign: 'left',
              },
            },
            {
              name: 'Collection',
              key: 'collection',
              styles: {
                maxWidth: '200px',
                textAlign: 'left',
              },
            },
            {
              name: 'User',
              key: 'created_by.email',
              styles: {
                maxWidth: '200px',
                textAlign: 'left',
              },
            },
            {
              name: 'Created At',
              key: 'created_at',
              render: (item) => <span>{dayjs(item.created_at).format('MM/DD/YYYY HH:mm')}</span>,
              sortable: true,
              styles: {
                maxWidth: '150px',
                textAlign: 'right',
              },
            },
          ]}
          entities="changelogs"
          searchable={false}
          filters={[
            {
              name: 'collection',
              label: 'Collection',
              options: collectionOptions,
              all: true,
              className: 'audiences__filters',
            },
            {
              name: 'created_by.email',
              label: 'User',
              options: createdByOptions,
              all: true,
              className: 'audiences__filters',
            },
            {
              name: 'created_by.org',
              label: 'Organization',
              options: orgOptions,
              all: true,
              className: 'audiences__filters',
            },
          ]}
          sort_key={'created_at'}
          sort_dir={-1}
        />
      </div>
      <Modal isOpen={details} onClose={() => setDetails(null)} className="changelogs__modal">
        <DiffModal details={details} />
      </Modal>
    </div>
  )
}

// export
export default Changelogs
